import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../styles/plastic.css'; // Assuming you are already using a custom CSS file
import Laptop1 from '../assets/images/laptop1.jpg';
import Laptop2 from '../assets/images/laptop2.jpg';
import Laptop3 from '../assets/images/laptop3.jpg';
import Laptop4 from '../assets/images/laptop4.jpg';


const Laptop = () => {
  const [customStyle, setCustomStyle] = useState(false); // Track the style toggle

  const images = [
    Laptop1,
    Laptop2,
    Laptop3,
    Laptop4,
   
   
  ];

  // Toggle custom styling
  const switchStyle = () => {
    setCustomStyle(!customStyle);
  };

  return (
    < div >
       <section className="about-container"> <h1>Laptop</h1></section>
       <br/><br/>
<div className="acer-container">
      {/* Gallery with hover animation */}
      <div className={`row ${customStyle ? "hover-effect-2" : "hover-effect-1"}`} id="gallery">
        {images.map((src, index) => (
          <div className="col-12 col-sm-6 col-lg-4 mb-4" key={index}>
            <img
              className="w-100 hover-img"
              src={src}
              alt={`Slide ${index + 1}`}
            />
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default Laptop;
